import { render, staticRenderFns } from "./DisabilitiesRateInput.vue?vue&type=template&id=48021254&"
import script from "./DisabilitiesRateInput.vue?vue&type=script&lang=js&"
export * from "./DisabilitiesRateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports